import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import CustomIcon from "../../../../../../../../../public/icons-v1_1";

type BannerLevel = "info" | "warning" | "danger";

interface Props {
  level: BannerLevel;
  title: string;
  description?: string;
}

const LEVEL_STYLE: Record<
  BannerLevel,
  { background: string; borderColor: string; iconColor: string }
> = {
  info: {
    background: "#F0F9FF",
    borderColor: "#48B5FE",
    iconColor: "#48B5FE",
  },
  warning: {
    background: "#FFFBEB",
    borderColor: "#FFD600",
    iconColor: "#B27700",
  },
  danger: {
    background: "#FFEEEE",
    borderColor: "#EE7D7A",
    iconColor: "#EE7D7A",
  },
};

// 주문 상태에 따라 상단에 노출되는 안내 배너(프레젠테이션 전용).
function PathPickOrderDetailBanner({ level, title, description }: Props) {
  const style = LEVEL_STYLE[level];

  return (
    <Flex
      gap={"8px"}
      padding={"16px"}
      borderRadius={"8px"}
      border={`0.5px solid ${style.borderColor}`}
      background={style.background}
    >
      <CustomIcon
        src={"warning-triangle"}
        width={16}
        height={16}
        color={style.iconColor}
      />
      <Flex flexDirection={"column"} gap={"4px"}>
        <Text textStyle={"body-sm-bold"} color={"#1D1D1B"}>
          {title}
        </Text>
        {description && (
          <Text textStyle={"body-sm-medium"} color={"#444440"}>
            {description}
          </Text>
        )}
      </Flex>
    </Flex>
  );
}

export default PathPickOrderDetailBanner;
